"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.otherTransactionsReducer = exports.transactionsReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var TransactionsState_init_1 = require("@/pages/common/states/TransactionsState.init");
var TransactionsAction_1 = require("@/pages/common/actions/TransactionsAction");
exports.transactionsReducer = function (state, action) {
    if (state === void 0) { state = TransactionsState_init_1.defaultTransactionsState; }
    switch (action.type) {
        case typesafe_actions_1.getType(TransactionsAction_1.default.setTransactions): {
            return __assign(__assign({}, state), { transactions: action.payload });
        }
        case typesafe_actions_1.getType(TransactionsAction_1.default.setCurrentPage): {
            return __assign(__assign({}, state), { transactionCurrentPage: action.payload });
        }
        default: {
            return state;
        }
    }
};
exports.otherTransactionsReducer = function (state, action) {
    if (state === void 0) { state = TransactionsState_init_1.defaultOtherTransactionsState; }
    return exports.transactionsReducer(state, action);
};
